var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('widget', [_c('widget-header', {
    staticClass: "background-gradient-green-blue text-white tiny-forms"
  }, [_c('i', {
    staticClass: "zmdi zmdi-file-plus pr-2"
  }), _vm._v(" Convert Lead to Activer User "), _c('h4', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('close-x', {
    staticClass: "text-white",
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  })], 1)]), _c('widget-body', [_c('form', {
    ref: "form",
    staticClass: "x-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.convertLead.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-1 gap-2"
  }, [_c('Superselect', {
    staticClass: "capitalize",
    attrs: {
      "title": "Role",
      "multiple": false,
      "options": ['publisher', 'advertiser'],
      "required": true
    },
    model: {
      value: _vm.account.role,
      callback: function ($$v) {
        _vm.$set(_vm.account, "role", $$v);
      },
      expression: "account.role"
    }
  }), _vm.account.role == 'publisher' && !_vm.lead.email ? _c('YInput', {
    attrs: {
      "label": "Email Required",
      "required": true
    },
    model: {
      value: _vm.account.email,
      callback: function ($$v) {
        _vm.$set(_vm.account, "email", $$v);
      },
      expression: "account.email"
    }
  }) : _vm._e(), _c('Superselect', {
    attrs: {
      "title": "Manager",
      "multiple": false,
      "track-by": "id",
      "label": "label",
      "query": _vm.ACCOUNT_MANAGER_OPTIONS_QUERY,
      "query-variables": {
        filters: {
          label: {
            value: [],
            modifiers: {
              matchType: 'contains'
            }
          }
        },
        first: 25
      },
      "required": true
    },
    model: {
      value: _vm.account.accountManager,
      callback: function ($$v) {
        _vm.$set(_vm.account, "accountManager", $$v);
      },
      expression: "account.accountManager"
    }
  }), _vm.account.role == 'advertiser' ? _c('div', {
    staticClass: "grid gap-2"
  }, [_c('YInput', {
    attrs: {
      "label": "Name",
      "required": true
    },
    model: {
      value: _vm.account.name,
      callback: function ($$v) {
        _vm.$set(_vm.account, "name", $$v);
      },
      expression: "account.name"
    }
  }), _c('YInput', {
    attrs: {
      "label": "Billing Name",
      "required": true
    },
    model: {
      value: _vm.account.billingName,
      callback: function ($$v) {
        _vm.$set(_vm.account, "billingName", $$v);
      },
      expression: "account.billingName"
    }
  })], 1) : _vm._e()], 1)])]), _c('widget-footer', {
    staticClass: "px-4 py-2 bg-gray-100 text-right"
  }, [_c('y-button', {
    staticClass: "btn btn-blue",
    attrs: {
      "is-loading": _vm.isSubmitting
    },
    on: {
      "click": _vm.convertLead,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.convertLead.apply(null, arguments);
      }
    }
  }, [_vm._v("Convert Lead")])], 1), _vm.validationErrors ? _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }